// src/components/NotFound.tsx hardened/refactored v1
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand via-branddark to-rose-700 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="mb-6">
          <h1 className="text-6xl font-bold text-branddark mb-2">404</h1>
          <p className="text-2xl font-semibold text-gray-800 mb-4">Page Not Found</p>
          <p className="text-gray-600">
            Oops! The page you're looking for doesn't exist.
          </p>
        </div>

        <div className="space-y-3">
          <Link
            to="/"
            className="block w-full bg-brand hover:bg-branddark text-white font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            Go Home
          </Link>
          
          <Link
            to="/contact"
            className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            Contact Support
          </Link>
        </div>

        <p className="mt-6 text-sm text-gray-500">
          Lost? We've all been there. 💕
        </p>
      </div>
    </div>
  );
}